import React, { useContext } from 'react';
import { getKcClsx } from 'keycloakify/login/lib/kcClsx';
import type { PageProps } from 'keycloakify/login/pages/PageProps';
import { Indent } from '@bankiru/ui-kit/components/Indent';
import { LinkText } from '@bankiru/ui-kit/components/Link/LinkText';
import Button from '@bankiru/ui-kit/core/Button';
import Text from '@bankiru/ui-kit/core/Text';

import { ThemeContext } from '../../../context/ThemeContextWrapper';
import { isMobilePlatform } from '../../../helpers/isMobilePlatform';
import type { I18n } from '../../i18n';
import type { KcContext } from '../../KcContext';

export default function LogoutConfirm(
	props: PageProps<Extract<KcContext, { pageId: 'logout-confirm.ftl' }>, I18n>,
) {
	const { kcContext, i18n, doUseDefaultCss, Template, classes } = props;

	const { platform, isIOS } = useContext(ThemeContext);

	const { kcClsx } = getKcClsx({
		doUseDefaultCss,
		classes,
	});

	const { url, client, logoutConfirm } = kcContext;

	const { msg, msgStr } = i18n;

	const isWebview = isMobilePlatform(platform) || isIOS;

	return (
		<Template
			kcContext={kcContext}
			i18n={i18n}
			doUseDefaultCss={doUseDefaultCss}
			classes={classes}
			headerNode={msgStr('logoutConfirmTitle')}
		>
			<div id="kc-logout-confirm" className="content-area">
				<Indent margin="8 0 0 0">
					<Text size="fs16" color="primary">
						{msg('logoutConfirmHeader')}
					</Text>
				</Indent>
				<form className="form-actions" action={url.logoutConfirmAction} method="POST">
					<input type="hidden" name="session_code" value={logoutConfirm.code} />
					<div className={kcClsx('kcFormGroupClass')}>
						<div id="kc-form-options">
							<div className={kcClsx('kcFormOptionsWrapperClass')}></div>
						</div>
						<div id="kc-form-buttons" className={kcClsx('kcFormGroupClass')}>
							<Button size="h48" type="submit" name="confirmLogout" isFullWidth>
								{msgStr('doLogout')}
							</Button>
						</div>
					</div>
				</form>
				<div id="kc-info-message">
					{!isWebview && !logoutConfirm.skipLink && client.baseUrl && (
						<p>
							<LinkText skin="blue" href={client.baseUrl}>
								{msg('backToApplication')}
							</LinkText>
						</p>
					)}
				</div>
			</div>
		</Template>
	);
}
